import type { AssembledGroup } from './types';

export type MatchResult =
  | { kind: 'correct'; categoryId: string }
  | { kind: 'one-away' }
  | { kind: 'wrong' };

function groupOf(
  tile: string,
  groups: AssembledGroup[],
): AssembledGroup | undefined {
  return groups.find((g) => g.members.includes(tile));
}

export function matchSelection(
  selection: string[],
  groups: AssembledGroup[],
): MatchResult {
  const counts = new Map<string, number>();
  for (const tile of selection) {
    const g = groupOf(tile, groups);
    if (!g) continue;
    counts.set(g.categoryId, (counts.get(g.categoryId) ?? 0) + 1);
  }
  for (const [categoryId, n] of Array.from(counts.entries())) {
    if (n === 4) return { kind: 'correct', categoryId };
    if (n === 3) return { kind: 'one-away' };
  }
  return { kind: 'wrong' };
}

const SQUARES: Record<1 | 2 | 3 | 4, string> = {
  1: '🟨',
  2: '🟩',
  3: '🟦',
  4: '🟪',
};

export function shareGrid(log: string[][], groups: AssembledGroup[]): string {
  return log
    .map((row) =>
      row
        .map((t) => {
          const g = groupOf(t, groups);
          return g ? SQUARES[g.difficulty] : '⬜';
        })
        .join(''),
    )
    .join('\n');
}
